'use strict';

var React = require('react');

const WithinContentContext = /*#__PURE__*/React.createContext(false);

exports.WithinContentContext = WithinContentContext;
